import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Image } from '@fluentui/react-components';
import { AssetItemPreviewBase } from './asset-preview-base/asset-item-preview-base';

export const ImagePreview = ({
  itemInfo,
  totalCount,
  currentIndex,
  onNext,
  onPrevious,
  shouldHideContent,
  i18n,
}) => {
  const { url: imageSrc } = itemInfo || {};

  const onRenderPreviewContent = useCallback(() => (
    <Image
      src={imageSrc}
      shouldFadeIn
      fit="contain"
      width="100%"
      height="100%"
      aria-label={i18n.getString(_TL_('image'))}
    />
  ), [i18n, imageSrc]);

  return (
    <AssetItemPreviewBase
      itemData={itemInfo}
      totalCount={totalCount}
      currentIndex={currentIndex}
      onNext={onNext}
      onPrevious={onPrevious}
      shouldHideContent={shouldHideContent}
      i18n={i18n}
      onRenderPreviewContent={onRenderPreviewContent}
    />
  );
};

ImagePreview.propTypes = {
  totalCount: PropTypes.number.isRequired,
  currentIndex: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
  shouldHideContent: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

ImagePreview.defaultProps = {
  shouldHideContent: false,
};
